//#region src/assets/throbber-card.svg
var throbber_card_default = "" + new URL("throbber-card-nLm8K7k3.svg", import.meta.url).href;
//#endregion
export { throbber_card_default as default };

//# sourceMappingURL=throbber-card.js.map